<template>
  <div>
    <el-dialog
        title="新增合作院校"
        :visible.sync="createDialog"
        width="930px">
      <div style="margin-left: 100px" v-loading="createLoading">
        <el-form label-position="top" :model="createdItem" :rules="rules" ref="formRef" label-width="110px">
          <el-row>
            <el-col :span="8">
              <el-form-item label-width="120px" label="院校名称" prop="name">
                <el-input v-model="createdItem.name" style="width: 200px" placeholder="请输入"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="7">
              <el-form-item label-width="120px" label="当前状态" prop="score">
                <el-select v-model="createdItem.state" placeholder="请选择" style="width: 200px">
                  <el-option label="洽谈中" :value="1"/>
                  <el-option label="合作中" :value="2"/>
                  <el-option label="已到期" :value="3"/>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8">
              <el-form-item label-width="120px" label="合同地址" prop="score">
                <el-button style="width: 200px;text-align: left;color: #c6c9d1" @click="$refs.fileManager.openDialog()">请选择</el-button>
              </el-form-item>
            </el-col>
            <el-col :span="16">
              <el-form-item label-width="120px" label="有效日期" prop="startAndEndDate">
                <el-date-picker style="width: 80%"
                                v-model="createdItem.startAndEndDate"
                                value-format="yyyy-MM-dd HH:mm:ss"
                                type="datetimerange"
                                range-separator="至"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期">
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="21">
              <el-form-item label-width="120px" label="备注说明">
                <el-input
                    type="textarea"
                    :rows="4"
                    placeholder="请输入"
                    v-model="createdItem.explain">
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="createDialog = false">取 消</el-button>
        <el-button type="danger" :disabled="createLoading" @click="created">确 定</el-button>
      </span>
    </el-dialog>
    <file-manager ref="fileManager"/>
  </div>
</template>

<script>
import {insertSchool} from '/src/api/contacts/hr/cooperationSchool'
import FileManager from "../../../../frame/components/header/components/fileManager/FileManager";
export default {
  name: "CreatedSchool",
  components:{FileManager},
  data() {
    return {
      createDialog: false,
      createLoading: false,
      createdItem: {
        name: "",
        startTime: null,
        endTime: null,
        state: null,
        explain: "",
      },
      rules: {
        name: [{required: true, message: "请输入院校名称！", trigger: "blur"}],
      }
    };
  },
  methods: {
    openDialog() {
      this.createDialog = true;
    },
    created() {
      console.log(this.createdItem)
      this.$refs.formRef.validate((valid) => {
        if (valid) {
          this.createLoading = true;
          this.createdItem.startTime = this.createdItem.startAndEndDate[0];
          this.createdItem.endTime = this.createdItem.startAndEndDate[1];
          insertSchool(this.createdItem).then(val => {
            this.createLoading = false;
            if (val.status == 200) {
              this.$emit('refresh');
              this.createDialog = false;
              this.$notify.success({title: '提示', message: '新增成功！', offset: 40});
              Object.keys(this.createdItem).forEach((key) => (this.createdItem[key] = null));
            } else {
              this.$notify.error({title: '新增失败！', message: val.data, offset: 40});
            }
          })
        }
      })
    },

  },
  created() {
  }
}

</script>

<style scoped>

</style>